import { inject, Inject, Injectable } from '@angular/core';

import { APP_CONFIG, AUTH_METHOD, AUTH_TOKEN } from '@core/common-legacy';
import { HttpApiRequestOptions, HttpRequestData, IdentityHeaders } from '@core/http-types';
import { ORG_GUID } from '@core/tellent-types';
import type { TellentAdminAppConfig } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class TellentAuthRequestData extends HttpRequestData {
  private orgGuid = inject(ORG_GUID);
  private authMethod = inject(AUTH_METHOD);
  private authToken = inject(AUTH_TOKEN);
  constructor(@Inject(APP_CONFIG) private config: TellentAdminAppConfig) {
    super();
  }
  public buildUrl(path: string, requestOptions: HttpApiRequestOptions): string {
    return `${this.config.tellentAuthUrl}${
      requestOptions.skipCompany ? '' : '/api/org/' + this.orgGuid
    }${path}`;
  }

  public provideAuthHeaders(): { Authorization: string } {
    return { Authorization: `${this.authMethod} ${this.authToken}` };
  }

  public provideIdentityHeaders(): IdentityHeaders {
    return {};
  }
}
